import React, {useState} from 'react';
import { exportToExcel, exportVerifiedToExcel } from '../../../utils/exportToExcel';
import { Button,Spinner  } from 'react-bootstrap';
import { getOrganisationListForExcel } from '../../../services/adminApiService/organisationApi/OrganisationApiService';


const DownloadExcelButton = ({data,headers,fileName, userId,
    searchValue,
    selectedDistrictId,
    selectedSubCategoryId,
    selectedSportId,btnName,onClick}) => {
    const [loading, setLoading] = useState(false);
  //   const handleClick = async () => {
  //   if (onClick) {
  //     // Case 2: fetch + export
  //     const fetchedData = await onClick();
  //     exportToExcel(fetchedData, headers, fileName);
  //   } else {
  //     // Case 1: direct export from state
  //     const finalData = data?.data || data;
  //     exportToExcel(finalData, headers, fileName);
  //   }
  // };

   const handleDataToExcel = async () => {
        try {
            setLoading(true);

            const response = await getOrganisationListForExcel(
                userId,
                searchValue,
                selectedDistrictId,
                selectedSubCategoryId,
                selectedSportId
            );

            const apiData = response.data;

            if (Number(userId) === 2) {
                exportVerifiedToExcel(apiData, "InstitutionListVerified.csv");
            } else {
                exportVerifiedToExcel(apiData, "IndividualListVerified.csv");
            }

        } catch (error) {
            console.error('Excel download error:', error);
        } finally {
            setLoading(false);  // stop loading after download
        }
    };
    
    const handleClick = async () => {
        try {
            setLoading(true);
             if (userId) {
            await handleDataToExcel();
            return
             }

            if (onClick) {
                // Case 2: fetch + export
                const fetchedData = await onClick();
                exportToExcel(fetchedData, headers, fileName);
            } else {
                // Case 1: direct export from state
                const finalData = data?.data || data;
                exportToExcel(finalData, headers, fileName);
            }
        } catch (error) {
            console.error("Excel download failed:", error);
        } finally {
            setLoading(false);
        }
    };
    return ( 
    // <Button
    //     variant="primary"
    //     onClick={handleClick}
    //     disabled={loading}
    // >
    //     {loading ? (
    //         <>
    //             <Spinner
    //                 as="span"
    //                 animation="border"
    //                 size="sm"
    //                 className="me-2"
    //             />
    //             Downloading...
    //         </>
    //     ) : (
    //         <>
    //             {btnName} <i className="fa fa-download ms-1"></i>
    //         </>
    //     )}
    // </Button>
     <Button
            variant="primary"
            onClick={handleClick}
            disabled={loading}
        >
            {loading ? (
                <>
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        className="me-2"
                    />
                    Downloading...
                </>
            ) : (
                <>
                    {btnName} <i className="fa fa-download ms-1"></i>
                </>
            )}
        </Button>
        );
};
export default DownloadExcelButton;